// removed by extract-text-webpack-plugin
module.exports = {"modal":"tlr3FhLpiHGIOU5xRQc-2","open":"_1zn11YdRl5s_XgiPGDqIfY","modalOverlay":"_2jngRsllrLGlh6hGR-k_Uy","modalContent":"Jr85Ugowsi9O8ObaBhr9i","scale":"_1PbCig_Cs2C2v7qKGoph6U","fadeUp":"TAeKbhOu-gj1Xfh8jU0-O","close":"_3kJsOUPesmzKfsVACCFZat"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/index.css
// module id = 153
// module chunks = 0